<template>
  <kds2-pop kind="menu" role="menu" above :anchor="anchor" :label="tx('menu.aria', { id: t.id })" @close="$emit('close')">
    <div v-if="confirm" class="k2-conf">
      <b>{{ tx("menu.confirm_t", { id: t.id }) }}</b>
      <span>{{ tx("menu.confirm_s") }}</span>
      <div>
        <button type="button" class="k2-danger" data-fk="ry" @click="$emit('reject', t.id)">{{ tx("menu.reject_yes") }}</button>
        <button type="button" data-fk="rn" @click="$emit('reject-no')">{{ tx("menu.reject_no") }}</button>
      </div>
    </div>
    <template v-else>
      <button type="button" role="menuitem" data-fk="mi-det" @click="$emit('det', t.id)">
        <k2-icon n="mdi-note-text-outline" :s="20" /><span>{{ tx("menu.details") }}</span>
      </button>
      <button v-if="back" type="button" role="menuitem" data-fk="mi-back" @click="$emit('back-step', t.id)">
        <k2-icon n="mdi-undo-variant" :s="20" /><span>{{ tx("menu.back", { state: backLabel }) }}</span>
      </button>
      <button v-if="canHold" type="button" role="menuitem" data-fk="mi-hold" @click="$emit('hold', t.id)">
        <k2-icon n="mdi-pause" :s="20" /><span>{{ tx("menu.hold") }}</span>
      </button>
      <button type="button" role="menuitem" class="k2-mi--bad" data-fk="mi-rej" @click="$emit('reject-ask', t.id)">
        <k2-icon n="mdi-cancel" :s="20" /><span>{{ tx("menu.reject") }}</span>
      </button>
    </template>
  </kds2-pop>
</template>

<script>
import K2Icon from "./K2Icon.vue";
import Kds2Pop from "./Kds2Pop.vue";
import kds2Text from "@/mixins/kds2Text";
import { backOf } from "@/utils/kdsTickets";

// Meni kartice ("⋯"): detalji, korak nazad, na čekanje, odbij (uz potvrdu). Ostala stanja su u detaljima.
export default {
  name: "Kds2Menu",
  components: { K2Icon, Kds2Pop },
  mixins: [kds2Text],
  props: {
    t: { type: Object, required: true },
    anchor: { default: null },
    confirm: { type: Boolean, default: false },
  },
  computed: {
    back() {
      return backOf(this.t);
    },
    // naziv stanja u koje se vraća, kao naziv kolone
    backLabel() {
      const map = { pending: "kds_new_orders", accepted: "in-progress", ready: "ready", delivered: "delivered" };
      return this.$t(map[this.back] || this.back);
    },
    canHold() {
      return this.t.state === "pending" || this.t.state === "accepted" || this.t.state === "in-progress";
    },
  },
};
</script>
